import { restApiDP } from "@plannel/services/utils/rest-api";
import ResponseUtil from "@plannel/pages/utils/response-util";

const user = JSON.parse(localStorage.getItem("user"));

const getBfAccuracy = (params) => {
    return restApiDP.get("/api/bf-accuracy", { params })
};

const getAllForCSV = params => {
    return restApiDP.get("/api/bf-accuracy/csv", { params });
};

const getAllForRawCSV = params => {
    params = ResponseUtil.getExportUrlSearchParameter(params);
    return fetch(`/api/bf-accuracy/raw-csv?${params}`, {
        method: "GET",
        headers: {
            "Content-type": "application/json",
            "x-tenant-id": user.tenantId,
            Authorization: `${user.type} ${user.accessToken}`,
            "x-module-name": "DP"
        }
    });
};

const bfAccuracyService = {
    getBfAccuracy,
    getAllForCSV,
    getAllForRawCSV
};

export default bfAccuracyService;